export function Footer() {
  return (
    <footer className="mt-24 border-t border-ink-700/60 bg-ink-950/60 py-10">
      <div className="container-prose flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="text-sm text-ink-300">
          <strong className="text-ink-100">verdadelectoral.com</strong> · Sitio ciudadano independiente.
          <br />
          No representa a ningún partido político.
        </div>
        <div className="text-xs text-ink-400">
          Búsqueda de la Verdad Electoral · EG2026 · Versión 0.1.0
        </div>
      </div>
    </footer>
  );
}
